export default "__VITE_ASSET__BwO421aA__"